import { render, staticRenderFns } from "./mobNewsDetails.vue?vue&type=template&id=7016a11d&scoped=true&"
import script from "./mobNewsDetails.vue?vue&type=script&lang=js&"
export * from "./mobNewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./mobNewsDetails.vue?vue&type=style&index=0&id=7016a11d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7016a11d",
  null
  
)

export default component.exports